export default __webpack_public_path__ + "static/media/whatsapp.32fa73ed.png";